import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ClinicalNoteApi } from '../../../apis/ClinicalNoteApi/ClinicalNoteApi';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { AppMedError } from '../../../error/AppMedError';
import { ClinicalNoteType, IClinicalNote, IClinicalNoteInput } from '../ClinicalNote';

export interface IUpsertClinicalNoteVariables {
    patientId: string;
    input: IClinicalNoteInput;
}

export function useUpsertClinicalNote(noteType: ClinicalNoteType, _i18nPrefix: string, patientId?: string | number) {
    const queryClient = useQueryClient();

    return useMutation<IClinicalNote, AppMedError, IUpsertClinicalNoteVariables>({
        mutationKey: [QueryKeys.clinicalNotes, noteType, 'upsert'],
        mutationFn: async ({ patientId: id, input }) => {
            return await ClinicalNoteApi.putClinicalNote(id, noteType, input);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [QueryKeys.clinicalNotes, noteType] });
            if (patientId != null)
                queryClient.invalidateQueries({ queryKey: [QueryKeys.clinicalNoteActivity, noteType, String(patientId)] });
        },
    });
}
